import { createAction } from 'typesafe-actions';

import { EParkingType } from 'shared/types/filters/advanced/parkingType';

export const setParkingType = createAction('filters/setParkingType')<EParkingType | undefined>();
